// Apple JS SDK yükleyici.
//
// SDK'yı index.html'e statik <script> olarak koymak yerine tıklama anında
// yüklüyoruz: aksi halde Apple'ın script'i (ve üçüncü taraf bağlantısı) her
// ziyaretçiye, her sayfada gider — üstelik buton sadece dev'de görünür.
// Ayrıca SDK URL'i locale içerdiği için build-time %VITE_*% substitution
// runtime dil değişimini takip edemezdi.

const APPLE_SDK_BASE =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1";

// Uygulama locale'leri (src/i18n/locales) -> Apple'ın beklediği locale kodları.
// Desteklenmeyen bir segment URL'de 404 döner, bu yüzden en_US'e düşüyoruz.
const APPLE_LOCALES: Record<string, string> = {
  ar: "ar_SA",
  de: "de_DE",
  en: "en_US",
  es: "es_ES",
  fr: "fr_FR",
  it: "it_IT",
  tr: "tr_TR",
};

export const getAppleLocale = (language?: string): string =>
  APPLE_LOCALES[(language || "en").split("-")[0]] || "en_US";

const loaders = new Map<string, Promise<void>>();

export function loadAppleSdk(locale: string): Promise<void> {
  if (window.AppleID) return Promise.resolve();

  const cached = loaders.get(locale);
  if (cached) return cached;

  const loader = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `${APPLE_SDK_BASE}/${locale}/appleid.auth.js`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      // Yeniden denenebilsin diye cache'i temizle.
      loaders.delete(locale);
      script.remove();
      reject(new Error("apple_sdk_load_failed"));
    };
    document.head.appendChild(script);
  });

  loaders.set(locale, loader);
  return loader;
}
